module.exports = __webpack_public_path__ + "ViasatAmerican-63170917391e23e476c15ecc57d2f00f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/ViasatAmerican.jpg
// module id = 1148
// module chunks = 0 1